import { render, staticRenderFns } from "./city-project.vue?vue&type=template&id=637ccb09"
import script from "./city-project.vue?vue&type=script&lang=js"
export * from "./city-project.vue?vue&type=script&lang=js"
import style0 from "./city-project.vue?vue&type=style&index=0&id=637ccb09&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports